import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';

import { ProgrammingEventService } from '../../../common/services/event.service';
import { Event } from '../../../common/interfaces/event.interface';

@Component({
  selector: 'prg-codeitem-summary',
  templateUrl: './codeitem-summary.component.html',
  styleUrls: ['./codeitem-summary.component.less']
})
export class CodeitemSummaryComponent {

  @Input() event: Event;

  editing: Observable<boolean>;

  constructor(
    private store: Store<any>,
    private router: Router,
    private eventService: ProgrammingEventService
  ) {
    this.editing = this.store.select(s => s.sharedProgramming.editing);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-common/codeitem-summary/codeitem-summary.component.ts